export enum RESET_TYPE {
  PASSWORD = 'password',
  PASSCODE = 'passcode',
}
